'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _paths = require('ifeis-isomorphic/lib/redux/actions/accounts/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/registrations/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/events/paths');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (allFeiseanna, user_id, mineFilter, statusFilter) {
  return function (state) {

    // Time periods
    var now = new Date().getTime();
    var fullDay = 86400000; // 24 hours
    var periodOfInterest = 7776000000; // 3 months

    var shortlistedNum = 8;
    var regsForMyFeiseanna = {};

    // Prepare feiseanna list
    // By default feiseanna should be sorted by start date
    var feiseanna = allFeiseanna.sort(function (a, b) {
      return a.feis.dt_start - b.feis.dt_start;
    });

    // Filter feiseanna based on status filter

    if (statusFilter) {
      if (statusFilter === 'completed') {
        // If we need to display the 'completed' feiseanna,
        // include feiseanna which are EITHER in the past OR have already been finalized
        // and order them by feis_end date
        feiseanna = feiseanna.filter(function (f) {
          return f.feis.dt_end + fullDay < now || f.feis.status === 'FINAL';
        }).sort(function (a, b) {
          return b.feis.dt_end - a.feis.dt_end;
        });
        shortlistedNum = feiseanna.length < shortlistedNum && 2 || shortlistedNum;
      } else if (statusFilter === 'active') {
        // If we need to display the 'active' feiseanna,
        // include feiseanna which are currently active AND have not been finalized.
        feiseanna = feiseanna.filter(function (f) {
          return f.feis.dt_end + fullDay > now && f.feis.status !== 'FINAL';
        });

        // On the Feiseanna page for all feiseanna in the Active list
        // the 'Show More' toggle should hide only those feiseanna that will start in 3 months or later
        if (mineFilter !== 'mine') {
          var nextFeiseannaToDisplay = feiseanna.filter(function (f) {
            return f.feis.dt_start <= now + periodOfInterest;
          });
          shortlistedNum = nextFeiseannaToDisplay.length;
        }
      }
    }

    // Prepare statuses for each feiseanna
    feiseanna = feiseanna.map(function (f) {
      return setFeisStatus(f);
    });

    // For MY active feiseanna on the Dashboard page
    // display a list of registrations for my dependents

    if (mineFilter === 'mine' && user_id) {
      feiseanna = feiseanna.filter(function (f) {
        return f.registered || f.saved;
      });
      feiseanna.forEach(function (f) {
        if (f.registered && f.registered > 0) {

          var myCompetitorsForFeis = [];

          (0, _paths.getMyCompetitorsForFeis)(state, user_id, f.feis_id).map(function (c) {
            // prepare my competitors list for a feis
            myCompetitorsForFeis = [].concat(_toConsumableArray(myCompetitorsForFeis), [_extends({}, c.toJS(), {
              registrations: ((0, _paths2.getRegistrationsForPerson)(state, f.feis_id, c.get('id')) || (0, _immutable.List)()).map(function (rid) {
                return (0, _paths3.getEvent)(state, rid);
              })
            })]);

            // update my feiseanna registrations list
            regsForMyFeiseanna = _extends({}, regsForMyFeiseanna, _defineProperty({}, f.feis_id, myCompetitorsForFeis));
          });
        }
      });
    }

    return {
      feiseanna: feiseanna,
      regsForMyFeiseanna: regsForMyFeiseanna,
      shortlistedNum: shortlistedNum
    };
  };
};

// Helpers

function setFeisStatus(f) {
  if (f.feis.status == 'FINAL') {
    f.status = {
      text: 'FINISHED',
      class: 'f-finished'
    };
  } else if (f.feis.status == 'PUBLIC') {
    f.status = {
      text: 'OPENING SOON',
      class: 'f-reg-not-started'
    };
  } else if (f.feis.status == 'NEW') {
    f.status = {
      text: 'REGISTRATION DATES ARE NOT FINALIZED',
      class: ''
    };
  } else if (f.feis.status == 'REG') {
    f.status = {
      text: 'REGISTRATION OPEN',
      class: 'f-reg-open'
    };
  } else if (f.feis.status == 'REG' && !!f.feis.dt_reg_late && this.now > f.feis.dt_reg_late) {
    f.status = {
      text: 'LATE REGISTRATION OPEN',
      class: 'f-late-reg-open'
    };
  } else if (f.feis.status == 'POST_REG') {
    f.status = {
      text: 'REGISTRATION CLOSED',
      class: 'f-reg-closed'
    };
  } else if (f.feis.status == 'IN_PROG') {
    f.status = {
      text: 'IN PROGRESS',
      class: 'f-in-progress'
    };
  }

  return f;
}


//////////////////
// WEBPACK FOOTER
// ./feis-list/mapStateToController.js
// module id = 481
// module chunks = 0